import Parse from "parse"
import moment from "moment"
import {
	actionWithLoader,
	getReplacingPath,
	haveAccessRight,
	onEnter,
	push
} from "../Utils/utils"
import {
	getDataServerUrl,
	KFC_BRANDS
} from "../../utils"
import { createOrLockStockLocker } from "../../parseManager/reception/parseLockerManager"
import {
	getDispatchLocker,
	freeLocker
} from "../../parseManager/dispatch/parseLockerManager"
import { getDistributionCentersByBrand } from "../../parseManager/planning/parsePlanningDashboardManager"
import {
	getInventoryProductsStock,
	getProductStockById,
	getReceptionProductsStock,
	updateProductStockInventory,
	updateProductStockInventoryStatus,
	updateProductStockTransfer,
	updateProductStockStatus,
	updateProductStockVolume,
	applyFlawToStock,
	updateInitialVolumeProductStocks,
	downloadProductsStocksInventory
} from "../../parseManager/reception/parseProductStockManager"
import {
	updateProductStockFCVolume
} from "../../api/fcStock"
import { getLostData } from "../../utils/receptionUtils"
import { areAllDeclaredFridgesCounted, inventoryTransfer, isInventoryFresh, isStockDeclared, transferAction } from "../../utils/inventoryUtils"
import { axiosCall } from "../../utils/axiosUtils"
import { loadSubcontractorsProductsByBrand } from "../Subcontractor/subcontractorsProducts"
import { exportCSVFile } from "../Products/SearchAdvanced"
import { MANAGEMENT_MODES_ENUM, WITH_MANAGEMENT_MODE_FILTER } from "../../utils/productTypesUtils"
import { getProductTypeOptions, loadProductTypeOptions } from "../ProductTypes/productTypes"
import { getProductTypes } from "../../parseManager/products/productTypeManager"
import { STOCK_TYPES, TRANSFER_REFUSALS, stockForType } from "../../utils/stockTypes"

export function onEnterReceptionFilter(store) {
	return onEnter({
		store,
		actionThunk: loadReceptionFilter,
		getReplacingPath: getReplacingPath({ needUser: true }),
		haveAccessRight: haveAccessRight({ canReadProductsStock: true })
	})
}

export function loadReceptionFilter() {
	return actionWithLoader(async (dispatch) => {
		const brand = KFC_BRANDS[0].name
		const date = moment.utc().startOf("day").valueOf()
		const hubs = await getDistributionCentersByBrand(brand)
		const filters = { ...WITH_MANAGEMENT_MODE_FILTER, brands: [brand] }
		dispatch(loadProductTypeOptions(filters))

		dispatch({
			type: "RECEPTION_FILTER_LOADED",
			date: date,
			brand: brand,
			hubs: hubs
		})
	})
}

export function loadReception(date, brand, hub) {
	return actionWithLoader(async (dispatch) => {
		try {
			const result = await getReceptionProductsStock(date, brand, hub)

			dispatch({
				type: "RECEPTION_LOADED",
				date,
				brand,
				hub,
				originalReceptionData: result
			})

			if (result.length > 0) {
				dispatch(showReception())
			} else {
				dispatch({
					type: "RECEPTION_OPEN_SNACKBAR",
					receptionSnackBar: { open: true, duration: 5000, type: "error", message: "Pas de résultat" }
				})
			}
		}
		catch (e) {
			dispatch({
				type: "RECEPTION_OPEN_SNACKBAR",
				receptionSnackBar: { open: true, duration: 5000, type: "error", message: "Erreur en récupérant les données" }
			})
		}
	})
}

export const downloadProductStocksInventoryCsv = () => {
	return actionWithLoader(async (dispatch) => {
		const productTypeOptions = await getProductTypeOptions()
		const productStockEventsCsvHeader = {
			hub: "Hub",
			productType: "Type",
			uniqueCode: "Code",
			commercialTitle: "Nom du produit",
			isReusable: "Packaging réutilisable",
			foodCost: "FoodCost",
			dlc: "DLC",
			volume: "Quantité",
			lastInventoryEventDate: "Date du dernier inventaire"
		}

		const rows = await downloadProductsStocksInventory(productTypeOptions)
		dispatch(exportCSVFile(productStockEventsCsvHeader, rows, "productStocksInventory"))
	})
}


export function onEnterInventoryFilter(store) {
	return onEnter({
		store,
		actionThunk: loadInventoryFilter,
		getReplacingPath: getReplacingPath({ needUser: true }),
		haveAccessRight: haveAccessRight({ canReadProductsStock: true })
	})
}

export function loadInventoryFilter() {
	return actionWithLoader(async (dispatch) => {
		const brand = KFC_BRANDS[0].name
		const startDate = moment.utc().startOf("day").valueOf()
		const hubs = await getDistributionCentersByBrand(brand)
		const filters = { managementMode: [MANAGEMENT_MODES_ENUM.none, MANAGEMENT_MODES_ENUM.onSite], brands: [brand] }
		const productTypeOptions = await getProductTypeOptions(filters)
		const productTypeNames = productTypeOptions.map(productType => productType.value)

		dispatch({
			type: "INVENTORY_FILTER_LOADED",
			date: startDate,
			brand: brand,
			hubs: hubs
		})
		dispatch(loadSubcontractorsProductsByBrand("FOODCHERI", productTypeNames))
		dispatch({
			type: "PRODUCT_TYPE_OPTIONS_LOADED",
			productTypeOptions,
		})

		// KFC-352: the options above are filtered on managementMode for the "add a product"
		// modal, which drops every "manual" category — Boisson among them. Ordering the
		// category bands needs the whole referential, so load it as well.
		dispatch({
			type: "PRODUCT_TYPES_LOADED",
			productTypes: await getProductTypes(),
		})
	})
}

export function loadInventory(brand, hub) {
	return actionWithLoader(async (dispatch) => {
		try {
			const result = await getInventoryProductsStock(brand, hub)

			dispatch({
				type: "INVENTORY_LOADED",
				brand,
				hub,
				originalInventoryData: result
			})

			// if (result.length > 0) {
				dispatch(showInventory())
			// } else {
			// 	dispatch({
			// 		type: "INVENTORY_OPEN_SNACKBAR",
			// 		inventorySnackBar: { open: true, duration: 5000, type: "success", message: "Pas de résultat" }
			// 	})
			// }
		} catch (e) {
			dispatch({
				type: "INVENTORY_OPEN_SNACKBAR",
				inventorySnackBar: { open: true, duration: 5000, type: "error", message: "Erreur en récupérant les données" }
			})
		}
	})
}

export const updateProductStock = ({ productStock, volume, lost = null, type, volumeLibreService }) => {
	return actionWithLoader(async (dispatch) => {
		try {
			let data, copy
			const date = moment.utc().valueOf()

			if (type === "RECEPTION") {
				const receptionEvent = [
					{
						type: "RECEPTION",
						user: Parse.User.current(),
						date: date,
						data: {
							volume: parseInt(volume),
							stockType: STOCK_TYPES.CLICK_AND_COLLECT
						}
					}]

				// What goes into the self-service fridge on a delivery comes off the truck, not out
				// of the click & collect one: it is a reception of its own, not a transfer. TRANSFER
				// is left to describe what it says — stock moving between the two fridges.
				if (volumeLibreService) {
					receptionEvent.push({
						type: "RECEPTION",
						user: Parse.User.current(),
						date,
						data: {
							volume: parseInt(volumeLibreService),
							stockType: STOCK_TYPES.LIBRE_SERVICE
						}
					})
				}

				data = receptionEvent
			}

			if (type === "INVENTORY") {
				data = [
					{
						type: "INVENTORY",
						user: Parse.User.current(),
						date: date,
						data: {
							oldVolume: parseInt(productStock.volume),
							newVolume: parseInt(volume),
							stockType: STOCK_TYPES.CLICK_AND_COLLECT
						}
					}]
			}

			// The counter manager picks the fridge; reception has none to offer and keeps the default.
			const flawStockType = (lost && lost.stockType) || STOCK_TYPES.CLICK_AND_COLLECT

			if (type === "LOSS") {
				data = [getLostData(lost, date, flawStockType)]
			}

			if (lost && type === "RECEPTION") {
				const dataLost = getLostData(lost, date, flawStockType)
				data = [...data, dataLost]
			}

			if (type === "LOSS") {
				const current = stockForType(productStock, flawStockType) || 0
				const remaining = Math.max(0, current - parseInt(volume))

				copy = await applyFlawToStock(productStock.objectId, flawStockType, remaining, data)
			} else {
				copy = await updateProductStockVolume(productStock.objectId, volume, data, type, volumeLibreService)
			}

			// KFC-284: also forward the self-service stock, so that FoodCheri can feed
			// HubProductionItem.stockInFridge separately from the click & collect one.
			// FoodCheri subtracts what a LOSS carries, so it must be the quantity broken, charged
			// to the fridge it came from — the other one gets zero and is left untouched.
			const brokenFrom = (stockType) => (flawStockType === stockType ? parseInt(volume) : 0)
			const fcVolume = type === "LOSS" ? brokenFrom(STOCK_TYPES.CLICK_AND_COLLECT) : parseInt(volume)
			const fcLibreService = type === "LOSS"
				? (lost && lost.stockType ? brokenFrom(STOCK_TYPES.LIBRE_SERVICE) : undefined)
				: (volumeLibreService === undefined || volumeLibreService === null ? undefined : parseInt(volumeLibreService))

			const result = await updateProductStockFCVolume(
				productStock.objectId,
				type,
				fcVolume,
				fcLibreService === undefined || fcLibreService === null ? undefined : parseInt(fcLibreService)
			)

			// necessary to define where the casse is from
			if (lost && lost.isInventory) type = "INVENTORY"

			if (!result) {
				if (type === "INVENTORY") {
					dispatch({
						type: "INVENTORY_OPEN_DETAIL_SNACKBAR",
						inventorySnackBar: { open: true, duration: 5000, type: "error", message: "Erreur lors de la mise à jour du volume sur FC" }
					})
				}
				else {
					dispatch({
						type: "RECEPTION_OPEN_DETAIL_SNACKBAR",
						receptionSnackBar: { open: true, duration: 5000, type: "error", message: "Erreur lors de la mise à jour du volume sur FC" }
					})
				}
			}

			await freeLocker(copy.objectId, "productStock")

			if (type === "INVENTORY") {
				return dispatch({
					type: "INVENTORY_SELECTED_PRODUCT_STOCK_UPDATED",
					selectedProduct: copy,
					inventorySnackBar: { open: true, duration: 5000, type: "success", message: "La mise à jour a été enregistrée" }
				})
			}

			return dispatch({
				type: "RECEPTION_SELECTED_PRODUCT_STOCK_UPDATED",
				selectedProduct: copy,
				receptionSnackBar: { open: true, duration: 5000, type: "success", message: "La mise à jour a été enregistrée" }
			})
		} catch (e) {
			// necessary to define where the casse is from
			if (lost && lost.isInventory) type = "INVENTORY"

			if (type === "INVENTORY") {
				dispatch({
					type: "INVENTORY_OPEN_DETAIL_SNACKBAR",
					inventorySnackBar: { open: true, duration: 5000, type: "error", message: "Erreur lors de la mise à jour" }
				})
			} else {
				dispatch({
					type: "RECEPTION_OPEN_DETAIL_SNACKBAR",
					receptionSnackBar: { open: true, duration: 5000, type: "error", message: "Erreur lors de la mise à jour" }
				})
			}
		}
	})
}

/** KFC-285: zero is a count, an absent value is not. */
const isCounted = (value) => value !== undefined && value !== null && "" !== value

/**
 * KFC-285: records an inventory on one fridge or on both.
 *
 * One `INVENTORY` event per fridge counted, each stamped with its `stockType` — the shape
 * KFC-191 settled on. A fridge left out of `counts` is not recounted: neither its stock nor its
 * history is touched, so the two fridges can be done in two passes within the freshness delay.
 *
 * Returns whether the inventory was recorded, so the panel can show the prototype's retry state
 * rather than the generic error banner.
 */
export const updateProductStockInventoryByFridge = ({ productStock, counts }) => {
	return actionWithLoader(async (dispatch) => {
		const date = moment.utc().valueOf()
		const events = []

		if (isCounted(counts.libreService)) {
			events.push({
				type: "INVENTORY",
				user: Parse.User.current(),
				date,
				data: {
					oldVolume: isStockDeclared(productStock.volumeLibreService) ? parseInt(productStock.volumeLibreService) : 0,
					newVolume: parseInt(counts.libreService),
					stockType: STOCK_TYPES.LIBRE_SERVICE
				}
			})
		}

		if (isCounted(counts.clickAndCollect)) {
			events.push({
				type: "INVENTORY",
				user: Parse.User.current(),
				date,
				data: {
					oldVolume: isStockDeclared(productStock.volume) ? parseInt(productStock.volume) : 0,
					newVolume: parseInt(counts.clickAndCollect),
					stockType: STOCK_TYPES.CLICK_AND_COLLECT
				}
			})
		}

		// Nothing counted: the panel guards against this, and there is nothing to write anyway.
		if (0 === events.length) return false

		// A recount that only moves units between the fridges is recorded as that move first,
		// then as the counts.
		const transfer = inventoryTransfer(productStock, counts)
		const transferEvent = transfer && { type: "TRANSFER", user: Parse.User.current(), date, data: transfer }

		if (transferEvent) events.unshift(transferEvent)

		let copy

		try {
			// The status is judged on the state the save will leave behind, not the one it starts
			// from: a fridge counted for the first time becomes declared, and can then complete
			// the product's inventory.
			const projected = { ...productStock, events: [...(productStock.events || []), ...events] }
			if (isCounted(counts.clickAndCollect)) projected.volume = parseInt(counts.clickAndCollect)
			if (isCounted(counts.libreService)) projected.volumeLibreService = parseInt(counts.libreService)

			copy = await updateProductStockInventory(
				productStock.objectId,
				counts,
				events,
				areAllDeclaredFridgesCounted(projected)
			)
		}
		catch (e) {
			// Nothing was written, so the panel keeps the entry and offers to retry, as DSG-36
			// does. Only this call is guarded: past it the inventory exists, and a retry would
			// write a second pair of events over a count that already succeeded.
			//
			// The panel shows one message for every cause, so the reason is traced here — a
			// permanent refusal and a dropped connection look identical on screen, and without
			// this line a product that can never be counted leaves nothing to investigate.
			console.error(`updateProductStockInventoryByFridge : ${productStock.objectId} non enregistré`, e)

			return false
		}

		// KFC-285: a stock message is a snapshot, not a delta — it carries both fridges as they
		// now stand, including the one that was not recounted. `volume` therefore stays
		// populated, which is what the FoodCheri route requires.
		const sent = await updateProductStockFCVolume(
			productStock.objectId,
			"INVENTORY",
			parseInt(isStockDeclared(copy.volumeClickAndCollect) ? copy.volumeClickAndCollect : copy.volume) || 0,
			isStockDeclared(copy.volumeLibreService) ? parseInt(copy.volumeLibreService) : undefined,
			transferEvent ? transferAction(transferEvent) : undefined
		)

		try {
			await freeLocker(copy.objectId, "productStock")
		}
		catch (e) {
			// Not a reason to present a recorded inventory as failed — but not harmless either:
			// a `LockerStock` has no expiry, neither here nor server-side, and the reader that
			// enforces it only filters on `isOver`. A lock left behind therefore blocks every
			// other user on that product until someone edits the database. Traced so the leak
			// can at least be found.
			console.error(`updateProductStockInventoryByFridge : verrou non libéré sur ${copy.objectId}`, e)
		}

		// KFC-285: one message, and it tells the truth.
		//
		// Dispatching a FoodCheri warning before this point would be pointless: both actions
		// write the same `inventoryDetailSnackBar`, so the success that follows a few
		// milliseconds later would erase the warning before anyone could read it — and the panel
		// closes on success, taking the context with it. The counter staff would be left
		// believing the count reached FoodCheri when it did not.
		const inventorySnackBar = sent
			? { open: true, duration: 5000, type: "success", message: "Inventaire validé." }
			: { open: true, duration: 10000, type: "error", message: "Inventaire enregistré, mais non transmis à FoodChéri." }

		dispatch({
			type: "INVENTORY_SELECTED_PRODUCT_STOCK_UPDATED",
			selectedProduct: copy,
			inventorySnackBar
		})

		return true
	})
}

/**
 * KFC-351 : declarer un transfert d'un frigo vers l'autre.
 *
 * Le garde-fou de DSG-36 est rejoue ici sur une RELECTURE du produit, pas sur l'instantane
 * Redux qui a servi a borner la saisie. La recette a montre pourquoi : panneau ouvert avec 8
 * unites, stock passe a 1 en base, clic — le transfert de 8 partait sans un mot, sortait 8
 * unites d'un frigo qui en contenait 1, et en creait 7 a partir de rien. Le bornage protege
 * de la faute de frappe, pas de ce qui bouge pendant qu'on regarde l'ecran.
 */
export const transferProductStock = ({ productStock, from, to, quantity }) => {
	return actionWithLoader(async (dispatch) => {
		const moved = parseInt(quantity)

		let current

		try {
			current = await getProductStockById(productStock.objectId)
		}
		catch (e) {
			// Sans relecture, on ne sait pas ce qu'on ecraserait : on prefere ne rien ecrire.
			console.error(`transferProductStock : ${productStock.objectId} illisible`, e)

			return TRANSFER_REFUSALS.WRITE_FAILED
		}

		// La relecture rend un objet Parse ; les drapeaux de comptage, eux, sont derives cote
		// client par `handleLastInventory` et n'existent que sur la copie Redux.
		const fresh = current ? current.toJSON() : productStock
		const sourceStock = STOCK_TYPES.LIBRE_SERVICE === from
			? fresh.volumeLibreService
			: fresh.volume
		const available = isStockDeclared(sourceStock) ? parseInt(sourceStock) : 0

		// CA-4 d'abord : un inventaire deja fait rend le transfert impossible quel que soit le
		// stock, et le message le dit mieux qu'un « stock insuffisant » exact mais trompeur.
		// Juge sur les evenements relus, pour qu'un inventaire pose entre-temps compte aussi.
		// Meme fenetre que la couleur de la tuile : passe deux heures, le comptage ne tient plus,
		// la tuile est redevenue blanche et le produit redevient transferable. Refuser alors un
		// transfert contredirait le critere, qui parle de « case verte ou grise ».
		const countedSince = (fresh.events || [])
			.filter(event => "INVENTORY" === event.type)
			.some(event => isInventoryFresh(event))

		if (productStock.countedLibreService || productStock.countedClickAndCollect || countedSince) {
			return TRANSFER_REFUSALS.INVENTORY_DONE
		}

		// CA-3 : `available < 1` couvre le frigo source vide, `moved > available` la quantite
		// devenue trop grande depuis l'ouverture du panneau.
		if (!(moved >= 1) || available < 1 || moved > available) {
			return TRANSFER_REFUSALS.NOT_ENOUGH_STOCK
		}

		const destinationStock = STOCK_TYPES.LIBRE_SERVICE === to
			? fresh.volumeLibreService
			: fresh.volume
		// Un frigo jamais renseigne vaut zero comme point de depart : le transfert le declare, ce
		// qui fait apparaitre sa tuile en vision frigo simple (cas T-3 et U-3 du ticket).
		const destinationBefore = isStockDeclared(destinationStock) ? parseInt(destinationStock) : 0

		const volumes = STOCK_TYPES.LIBRE_SERVICE === from
			? { libreService: available - moved, clickAndCollect: destinationBefore + moved }
			: { libreService: destinationBefore + moved, clickAndCollect: available - moved }

		// Un seul evenement : le transfert est une operation unique dont le sens est porte par
		// `from` et `to`. `oldVolume` et `newVolume` decrivent le frigo de depart, comme pour un
		// inventaire, pour que la lecture d'un historique reste homogene.
		const event = {
			type: "TRANSFER",
			user: Parse.User.current(),
			date: moment.utc().valueOf(),
			data: {
				quantity: moved,
				from,
				to,
				oldVolume: available,
				newVolume: available - moved
			}
		}

		let copy

		try {
			copy = await updateProductStockTransfer(productStock.objectId, volumes, event)
		}
		catch (e) {
			// Rien n'est ecrit : le panneau garde la saisie et propose de reessayer, comme pour
			// l'inventaire. Seul cet appel est garde — au-dela le transfert existe, et un reessai
			// deplacerait le stock une seconde fois.
			console.error(`transferProductStock : ${productStock.objectId} non enregistré`, e)

			return TRANSFER_REFUSALS.WRITE_FAILED
		}

		// KFC-351 : on publie avec le type `TRANSFER`. `hub` porte l'etat APRES transfert, et
		// `transfer` le mouvement que FoodCheri historise.
		const sent = await updateProductStockFCVolume(
			productStock.objectId,
			"TRANSFER",
			parseInt(isStockDeclared(copy.volumeClickAndCollect) ? copy.volumeClickAndCollect : copy.volume) || 0,
			isStockDeclared(copy.volumeLibreService) ? parseInt(copy.volumeLibreService) : undefined,
			transferAction(event)
		)

		try {
			await freeLocker(copy.objectId, "productStock")
		}
		catch (e) {
			// Un `LockerStock` n'expire pas : un verrou laisse derriere bloque tout le monde sur
			// ce produit jusqu'a intervention en base. Trace pour qu'il soit au moins trouvable.
			console.error(`transferProductStock : verrou non libéré sur ${copy.objectId}`, e)
		}

		dispatch({
			type: "INVENTORY_SELECTED_PRODUCT_STOCK_UPDATED",
			selectedProduct: copy,
			inventorySnackBar: sent
				? { open: true, duration: 5000, type: "success", message: "Transfert enregistré." }
				: { open: true, duration: 10000, type: "error", message: "Transfert enregistré, mais non transmis à FoodChéri." }
		})

		return TRANSFER_REFUSALS.NONE
	})
}

export function filterByStatus(status, isInventory = false) {
	if (isInventory) {
		return actionWithLoader(async (dispatch) => {
			dispatch({
				type: "INVENTORY_FILTER_STATUS_SET",
				inventoryStatus: status
			})
		})
	}

	return actionWithLoader(async (dispatch) => {
		dispatch({
			type: "RECEPTION_FILTER_STATUS_SET",
			receptionStatus: status
		})
	})
}

/**
 * KFC-352: switches the inventory tiles between both fridges and each one on its own.
 *
 * Inventory only: the reception screen has no such filter.
 */
export function filterByFridge(fridgeFilter) {
	return actionWithLoader(async (dispatch) => {
		dispatch({
			type: "INVENTORY_FILTER_FRIDGE_SET",
			fridgeFilter
		})
	})
}

export function filterByNameOrCode(name, isInventory = false) {
	if (isInventory) {
		return actionWithLoader(async (dispatch) => {
			dispatch({
				type: "INVENTORY_FILTER_NAME_OR_CODE_SET",
				searchFilter: name
			})
		})
	}

	return actionWithLoader(async (dispatch) => {
		dispatch({
			type: "RECEPTION_FILTER_NAME_OR_CODE_SET",
			searchFilter: name
		})
	})
}

export function resetStatus(productStock, isInventory = false) {
	return actionWithLoader(async (dispatch) => {
		try {
			let copy = await getProductStockById(productStock.objectId)

			copy = (isInventory) ?
				await updateProductStockInventoryStatus(copy, true) :
				await updateProductStockStatus(copy, true)

			await freeLocker(productStock.objectId, "productStock")

			if (isInventory) {
				return dispatch({
					type: "INVENTORY_SELECTED_PRODUCT_STOCK_UPDATED_STATUS",
					selectedProduct: copy,
					noDisplay: false,
					reset: true
				})
			}

			return dispatch({
				type: "RECEPTION_SELECTED_PRODUCT_STOCK_UPDATED_STATUS",
				selectedProduct: copy,
				noDisplay: false,
				reset: true
			})
		}
		catch (e) {
			if (isInventory) {
				dispatch({
					type: "INVENTORY_OPEN_DETAIL_SNACKBAR",
					noDisplay: false,
					inventorySnackBar: { open: true, duration: 5000, type: "error", message: "Erreur lors de la mise à jour" }
				})
			} else {
				dispatch({
					type: "RECEPTION_OPEN_DETAIL_SNACKBAR",
					noDisplay: false,
					receptionSnackBar: { open: true, duration: 5000, type: "error", message: "Erreur lors de la mise à jour" }
				})
			}
		}
	})
}

export function updateStatus(productStock, isInventory = false) {
	return actionWithLoader(async (dispatch) => {
		try {
			let copy = await getProductStockById(productStock.objectId)

			// for inventory
			if (isInventory) {
				// set to in progress
				if (copy.get("inventoryStatus") === "TODO") {
					copy = await updateProductStockInventoryStatus(copy)
				} else {
					const stockLocker = await getDispatchLocker(productStock.objectId, "productStock")

					//Cancel action if locker exist
					if (stockLocker) {
						dispatch({
							type: "INVENTORY_OPEN_DETAIL_SNACKBAR",
							noDisplay: true,
							inventorySnackBar: { open: true, duration: 5000, type: "error", message: "Un inventaire est en train d'être fait sur ce produit" }
						})

						return
					}

					copy = copy.toJSON()
				}

				await createOrLockStockLocker(productStock.objectId)
				return dispatch({
					type: "INVENTORY_SELECTED_PRODUCT_STOCK_UPDATED_STATUS",
					selectedProduct: copy,
					noDisplay: false,
					reset: false
				})
			} else {
				// set to in progress
				if (copy.get("receptionStatus") === "TODO") {
					copy = await updateProductStockStatus(copy)
				} else {
					const stockLocker = await getDispatchLocker(productStock.objectId, "productStock")

					//Cancel action if locker exist
					if (stockLocker) {
						dispatch({
							type: "RECEPTION_OPEN_DETAIL_SNACKBAR",
							noDisplay: true,
							receptionSnackBar: { open: true, duration: 5000, type: "error", message: "une réception est en train d’être faite sur ce produit" }
						})

						return
					}

					copy = copy.toJSON()
				}

				await createOrLockStockLocker(productStock.objectId)
				return dispatch({
					type: "RECEPTION_SELECTED_PRODUCT_STOCK_UPDATED_STATUS",
					selectedProduct: copy,
					noDisplay: false,
					reset: false
				})
			}
		} catch (e) {
			if (isInventory) {
				dispatch({
					type: "INVENTORY_OPEN_DETAIL_SNACKBAR",
					noDisplay: true,
					inventorySnackBar: { open: true, duration: 5000, type: "error", message: "Erreur lors de la mise à jour" }
				})
			} else {
				dispatch({
					type: "RECEPTION_OPEN_DETAIL_SNACKBAR",
					noDisplay: true,
					receptionSnackBar: { open: true, duration: 5000, type: "error", message: "Erreur lors de la mise à jour" }
				})
			}
		}
	})
}

export function closeReceptionSnackBar(currentType) {
	return actionWithLoader(async (dispatch) => {
		dispatch({
			type: "RECEPTION_CLOSE_SNACKBAR",
			receptionSnackBar: { open: false, type: currentType, message: "", duration: 1000 }
		})
	})
}

export function closeReceptionDetailSnackBar(currentType) {
	return actionWithLoader(async (dispatch) => {
		dispatch({
			type: "RECEPTION_CLOSE_DETAIL_SNACKBAR",
			receptionSnackBar: { open: false, type: currentType, message: "", duration: 1000 }
		})
	})
}

// share the same store
export function showReception() {
	return push("/reception")
}

export function showReceptionInterface() {
	return push("/receptionFilter")
}

export function closeInventorySnackBar(currentType) {
	return actionWithLoader(async (dispatch) => {
		dispatch({
			type: "INVENTORY_CLOSE_SNACKBAR",
			inventorySnackBar: { open: false, type: currentType, message: "", duration: 1000 }
		})
	})
}

export function closeInventoryDetailSnackBar(currentType) {
	return actionWithLoader(async (dispatch) => {
		dispatch({
			type: "INVENTORY_CLOSE_DETAIL_SNACKBAR",
			inventorySnackBar: { open: false, type: currentType, message: "", duration: 1000 }
		})
	})
}

export function showErrors(error, isInventory) {
	return actionWithLoader(async (dispatch) => {
		if (isInventory) {
			dispatch({
				type: "INVENTORY_OPEN_DETAIL_SNACKBAR",
				inventorySnackBar: { open: true, duration: 5000, type: "error", message: error }
			})
		} else {
			dispatch({
				type: "RECEPTION_OPEN_DETAIL_SNACKBAR",
				receptionSnackBar: { open: true, duration: 5000, type: "error", message: error }
			})
		}
	})
}

export function validateAddDisplay(productSelected) {
	return actionWithLoader(async (dispatch) => {
		const productStocks = await updateInitialVolumeProductStocks(productSelected)

		dispatch({
			type: "RECEPTION_ADD_PRODUCTS",
			receptionSnackBar: { open: true, duration: 5000, type: "success", message: "Produits ajoutés" },
			productStocks
		})
	})
}

export function brandChange(brand) {
	return actionWithLoader(async (dispatch) => {
		const hubs = await getDistributionCentersByBrand(brand)

		dispatch({
			type: "FILTER_BRAND_UPDATED",
			brand,
			hubs
		})
	})
}

export function sendProductPlacement(selectedHub) {
	return actionWithLoader(async (dispatch) => {
		const user = Parse.User.current() ? Parse.User.current().get("email") : null

		if (user) {
			const url = `${getDataServerUrl()}/planigramme?sdate=${moment().format("YYYY-MM-DD")}&hubs=[${selectedHub[0].objectId}]&dest=${user}`

			const result = await axiosCall("GET", url, null, { "Content-Type": "application/json" })

			if (result.status === 200) {
				dispatch({
					type: "INVENTORY_OPEN_DETAIL_SNACKBAR",
					inventorySnackBar: { open: true, duration: 5000, type: "success", message: "Planigramme envoyé sur votre email" }
				})
			}
			else {
				dispatch({
					type: "INVENTORY_OPEN_DETAIL_SNACKBAR",
					inventorySnackBar: { open: true, duration: 5000, type: "error", message: "Echec de l'envoie du Planigramme" }
				})
			}
		}
		else {
			dispatch({
				type: "INVENTORY_OPEN_DETAIL_SNACKBAR",
				inventorySnackBar: { open: true, duration: 5000, type: "error", message: "Utilisateur non trouvé" }
			})
		}
	})
}

// share the same store
export function showInventory() {
	return push("/inventory")
}

export function showInventoryInterface() {
	return push("/inventoryFilter")
}
